module.exports = __webpack_public_path__ + "img/g_angelov.1c2d76f1.jpg";